import { prop, modify, isNil } from 'ramda';

export const DEFAULT_PHONE = { internationalCode: '+33' };

export const ensurePhonesArray = (data) =>
  isNil(prop('phones', data))
    ? modify('phones', () => [DEFAULT_PHONE], data)
    : data;
